import React from "react";
import appLogo from "../../assets/applogo.png";

const Logo = ({ ...props }) => {
  return <img {...props} src={appLogo} alt="logo" />;
};

export default Logo;
